import React from 'react';
import { FiLoader } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';

const LoadingSpinner = ({ size = 'md', color = 'blue', fullScreen = false, text = '', className = '' }) => {
  const { theme } = useTheme();
  const primaryColor = theme.primaryColor;
  const sizes = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12', xl: 'w-16 h-16' };
  const colors = { blue: primaryColor, gray: 'text-gray-600', white: 'text-white', red: 'text-red-600', green: 'text-green-600' };

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50">
        <div className="text-center">
          <FiLoader className={`${sizes.lg} animate-spin mx-auto mb-4`} style={{ color: colors[color] || primaryColor }} />
          {text && <p className="text-gray-600">{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <FiLoader className={`${sizes[size]} animate-spin`} style={{ color: colors[color] || primaryColor }} />
      {text && <span className="ml-2 text-gray-600">{text}</span>}
    </div>
  );
};

LoadingSpinner.Inline = ({ size = 'sm', color = 'blue', className = '' }) => {
  const { theme } = useTheme();
  const primaryColor = theme.primaryColor;
  const sizes = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12', xl: 'w-16 h-16' };
  const colors = { blue: primaryColor, gray: 'text-gray-600', white: 'text-white', red: 'text-red-600', green: 'text-green-600' };
  return <FiLoader className={`${sizes[size]} animate-spin ${className}`} style={{ color: colors[color] || primaryColor }} />;
};

LoadingSpinner.Page = ({ text = 'Loading...' }) => {
  const { theme } = useTheme();
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <FiLoader className="w-12 h-12 animate-spin mx-auto mb-4" style={{ color: theme.primaryColor }} />
        <p className="text-gray-600">{text}</p>
      </div>
    </div>
  );
};

LoadingSpinner.Skeleton = ({ type = 'card', count = 1 }) => {
  if (type === 'card') {
    return (
      <>
        {[...Array(count)].map((_, i) => (
          <div key={i} className="bg-white rounded-lg shadow-md p-4 animate-pulse">
            <div className="w-full h-48 bg-gray-200 rounded-lg mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
          </div>
        ))}
      </>
    );
  }
  if (type === 'text') {
    return (
      <div className="space-y-2 animate-pulse">
        {[...Array(count)].map((_, i) => (
          <div key={i} className="h-4 bg-gray-200 rounded w-full"></div>
        ))}
      </div>
    );
  }
  if (type === 'profile') {
    return (
      <div className="flex items-center space-x-4 animate-pulse">
        <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    );
  }
  return null;
};

export default LoadingSpinner;